import actions from './moduleVesselReportExportActions.js'

export default {
  isRegistered: false,
  namespaced: true,
  actions: actions
}
